import React from 'react';
import Button from './elements/Button';

const ConfirmModal = ({ open, title, message, onConfirm, onCancel, cancelText = 'No', confirmText = 'Yes' }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 font-sans">
      <div className="bg-card-background rounded-lg shadow-lg p-6 min-w-[300px] max-w-[90vw] border border-accent-main">
        <h3 className="text-lg font-semibold mb-2 text-primary-dark font-sans">{title || 'Confirm'}</h3>
        <p className="mb-4 text-text-dark font-sans">{message || 'Are you sure you want to proceed?'}</p>
        <div className="flex justify-end gap-2 font-sans">
          {onCancel && <Button type='secondary' onClick={onCancel}>{cancelText}</Button>}
          <Button type='danger' onClick={onConfirm}>{confirmText}</Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
